// src/pages/AccountPage.jsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateUserProfile } from '../firebase/services';
import Toast from '../components/Toast';

export default function AccountPage() {
  const { user, userData, refreshUserData } = useAuth();
  const [form, setForm] = useState({ displayName: user?.displayName || '', phone: userData?.phone || '' });
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const s = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateUserProfile(user.uid, { displayName: form.displayName, phone: form.phone });
      await refreshUserData();
      setToast({ message: 'Profile updated!', type: 'success' });
    } catch {
      setToast({ message: 'Update failed', type: 'error' });
    } finally { setSaving(false); }
  };

  return (
    <div style={{ paddingTop: 68, minHeight: '80vh' }}>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
      <div style={{ background: 'var(--bg-2)', borderBottom: '1px solid var(--border)', padding: 'clamp(20px, 5vw, 44px) clamp(16px, 5vw, 40px) clamp(16px, 3vw, 32px)' }}>
        <div className="container" style={{ padding: 0 }}>
          <p className="section-eyebrow">Settings</p>
          <h1 className="section-title">My Account</h1>
        </div>
      </div>

      <div className="container" style={{ padding: 'clamp(20px, 4vw, 44px) clamp(16px, 4vw, 40px)', maxWidth: 660 }}>
        {/* Avatar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32, padding: '20px', flexWrap: 'wrap', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg, var(--gold), var(--gold-3))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Playfair Display, serif', fontSize: 26, fontWeight: 400, color: '#09080A', flexShrink: 0 }}>
            {(user?.displayName || user?.email || 'U')[0].toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 500, marginBottom: 3 }}>{user?.displayName || 'Member'}</div>
            <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{user?.email}</div>
            <div style={{ marginTop: 6 }}><span className={`badge ${userData?.role === 'admin' ? 'badge-gold' : 'badge-emerald'}`}>{userData?.role === 'admin' ? '⚙ Admin' : '✦ Member'}</span></div>
          </div>
        </div>

        <form onSubmit={handleSave}>
          <div className="form-group">
            <label className="label">Display Name</label>
            <input className="input" value={form.displayName} onChange={e => s('displayName', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="label">Email Address</label>
            <input className="input" value={user?.email || ''} disabled style={{ opacity: 0.5 }} />
          </div>
          <div className="form-group">
            <label className="label">Phone Number</label>
            <input className="input" value={form.phone} onChange={e => s('phone', e.target.value)} placeholder="+91 98765 43210" />
          </div>
          <button type="submit" className="btn btn-gold" disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
}
